import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tabela',
  standalone: true,
  imports: [],
  templateUrl: './tabela.component.html',
  styleUrl: './tabela.component.css'
})
export class TabelaComponent {
  @Input() carregando = false;
  @Input() linhasSkeleton = 5;
  @Input() colunasSkeleton = 5;
  @Input() maxHeight = 'none';

  get linhasSkeletonArray(): number[] {
    return Array.from({ length: this.linhasSkeleton });
  }

  get colunasSkeletonArray(): number[] {
    return Array.from({ length: this.colunasSkeleton });
  }
}
